module.exports = __webpack_public_path__ + "static/img/ls.9792798.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audit/ls.png
// module id = rYH9
// module chunks = 1